import Widget from './widget';
export var HistoryWidget = Widget;
